import {
  Stack,
  TextField,
  Typography,
  Autocomplete,
  CircularProgress
} from '@mui/material';
import { GridFilterInputValueProps } from '@mui/x-data-grid';

import { useFetchEvaluations } from '@/hooks/queries/evaluations';

export type EvaluationOption = { id: number; title: string };

const FilterEvaluations = ({ item, applyValue }: GridFilterInputValueProps) => {
  const { data: evaluationsResponse, isLoading } = useFetchEvaluations({
    fullRequest: true
  });
  const evaluations = evaluationsResponse?.results || [];

  const uniqueEvaluations = evaluations.filter(
    (evaluation, index, self) =>
      index === self.findIndex((e) => e.title === evaluation.title)
  );

  const getSelectedValue = () => {
    if (!item.value) return null;
    if (
      typeof item.value === 'object' &&
      item.value !== null &&
      'id' in item.value
    ) {
      return (
        uniqueEvaluations.find((option) => option.id === item.value.id) || null
      );
    }
    if (typeof item.value === 'number') {
      return (
        uniqueEvaluations.find((option) => option.id === item.value) || null
      );
    }
    if (typeof item.value === 'string') {
      const id = Number(item.value);
      return uniqueEvaluations.find((option) => option.id === id) || null;
    }
    return null;
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 48
        }}
      >
        <CircularProgress size={20} color="inherit" />
      </div>
    );
  }

  return (
    <Autocomplete
      value={getSelectedValue()}
      loading={isLoading}
      options={evaluations}
      onChange={(_, newValue) => applyValue({ ...item, value: newValue })}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option: EvaluationOption) => option.title}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          size="small"
          label="Evaluations"
          sx={{ minWidth: 350, pr: '10px', mt: 0.4 }}
          placeholder={isLoading ? 'Loading...' : 'Select evaluations'}
        />
      )}
      renderOption={(props, option) => (
        <li {...props} key={option.id}>
          <Stack
            direction="row"
            alignItems="center"
            style={{ margin: '5px 0px' }}
          >
            <Typography>{option.title}</Typography>
          </Stack>
        </li>
      )}
    />
  );
};

export default FilterEvaluations;
